const LOWERCASE_WORDS = new Set([
  'a',
  'an',
  'and',
  'as',
  'at',
  'but',
  'by',
  'for',
  'from',
  'in',
  'of',
  'on',
  'or',
  'per',
  'the',
  'to',
  'with'
]);

const UPPERCASE_WORDS = new Set([
  'ai',
  'bbq',
  'blt',
  'oc',
  'usa'
]);

function cleanMenuText(value) {
  if (!value || !value.trim()) return value;

  return value
    .replace(/\s+([,.;:])/g, '$1')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

function capitalizeWord(word) {
  if (!word) return word;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

function formatToken(token, index, totalTokens) {
  if (!token) return token;

  const parts = token.split(/([-/'&]+)/);
  return parts
    .map(part => {
      if (/^[-/'&]+$/.test(part)) return part;

      const normalized = part.toLowerCase();
      if (UPPERCASE_WORDS.has(normalized)) {
        return normalized.toUpperCase();
      }

      if (index !== 0 && index !== totalTokens - 1 && LOWERCASE_WORDS.has(normalized)) {
        return normalized;
      }

      return capitalizeWord(part);
    })
    .join('');
}

export function toMenuTitleCase(value) {
  if (!value || !value.trim()) return value;

  const tokens = cleanMenuText(value).split(/\s+/);
  return tokens.map((token, index) => formatToken(token, index, tokens.length)).join(' ');
}

export function formatMenuDescription(value) {
  return cleanMenuText(value || '');
}

export function formatParsedMenu(menu) {
  if (!menu || !Array.isArray(menu.categories)) return menu;

  return {
    ...menu,
    categories: menu.categories.map(category => ({
      ...category,
      name: toMenuTitleCase(category.name || ''),
      items: Array.isArray(category.items)
        ? category.items.map(item => ({
            ...item,
            name: toMenuTitleCase(item.name || ''),
            description: formatMenuDescription(item.description || '')
          }))
        : []
    }))
  };
}
